<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{fHeader}} {{headerInfo.filename}}</h2>

<div mat-dialog-content *ngIf="headerInfo.sessionCount == 0">
    <span class="notfound">{{fNoSession}}</span>
</div>

<div mat-dialog-content *ngIf="headerInfo.sessionCount > 0" class="session-table-div">
    <table>
        <caption>Header Information</caption>
        <thead>
            <th class="session-header" id="session-header">{{fSessions}}</th>
        </thead>
        <tbody class="session-table-body">
            <tr class="session-row" *ngFor="let session of headerInfo.sessions">
                <td class="session-data">{{fScope}} {{session.scopeDisplay}}<br>
                {{fUUID}} {{session.uuid}}<br>
                {{fInfo}} {{session.info}}<br>
                {{fPrivate}} {{session.hasPrivateKey}}<br>
                {{fProtected}} {{session.hasProtectedKey}}<br><br></td>
            </tr>
        </tbody>
    </table>
</div>

<mat-dialog-actions>
    <button mat-raised-button (click)="close()" style="background-color: #194e84; color: white; float: right;" >{{fClose}}</button>
</mat-dialog-actions>
